import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function TripAdvisor(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#36DB9A" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M12.3534 11.0477C12.8013 10.0476 13.6006 9.28709 14.6053 8.90577C15.0208 8.747 15.4453 8.66904 15.8656 8.65557C14.719 8.12824 13.4208 7.86033 11.9833 7.86033C10.5542 7.86033 9.23664 8.13533 8.08931 8.63927C10.1628 8.68251 11.8524 10.3517 12.0006 12.4567C12.0371 11.9762 12.1515 11.4992 12.3534 11.0477ZM4.81196 12.757C4.81196 14.5694 6.24595 16.0443 8.00932 16.0443C9.77269 16.0443 11.2067 14.5694 11.2067 12.757C11.2067 10.9433 9.77269 9.46692 8.00932 9.46692C6.24595 9.46692 4.81196 10.9433 4.81196 12.757ZM12.994 13.9119C13.2889 14.7347 13.8781 15.3911 14.654 15.7589C15.4306 16.1275 16.2995 16.1622 17.1009 15.8589C18.7547 15.2288 19.6037 13.3335 18.9925 11.6324C18.3826 9.93138 16.5393 9.05817 14.8848 9.68685C14.0834 9.99021 13.4453 10.5976 13.0877 11.3957C12.7308 12.1938 12.6977 13.0868 12.994 13.9111V13.9119ZM19.9959 8.66879C19.9959 8.66879 19.3971 9.49238 19.2083 10.3167C19.4309 10.6236 19.6163 10.9666 19.7513 11.3437C20.5176 13.4736 19.4536 15.8494 17.3809 16.6382C16.3769 17.0196 15.2881 16.9749 14.3151 16.5135C13.7301 16.2364 13.2319 15.8267 12.8453 15.3199L11.9846 16.6439L11.1322 15.3306C10.3977 16.2725 9.27102 16.8771 8.00861 16.8771C5.7994 16.8771 4.00158 15.0293 4.00158 12.757C4.00158 11.8441 4.29513 11.0035 4.78369 10.3209C4.59075 9.5016 3.99951 8.68793 3.99951 8.68793L6.50847 8.6858C7.99965 7.68359 9.88982 7.14209 11.9833 7.14209C14.0016 7.14209 15.8242 7.67013 17.323 8.66737L19.9959 8.66879ZM7.95735 10.9654C7.01276 10.9654 6.25002 11.7499 6.25002 12.7197C6.25002 13.6858 7.01276 14.4758 7.95735 14.4758C8.89664 14.4758 9.66291 13.6858 9.66291 12.7197C9.66291 11.7499 8.89664 10.9654 7.95735 10.9654ZM15.9845 10.9654C15.0399 10.9654 14.2807 11.7499 14.2807 12.7197C14.2807 13.6858 15.0399 14.4758 15.9845 14.4758C16.9256 14.4758 17.6883 13.6858 17.6883 12.7197C17.6883 11.7499 16.9256 10.9654 15.9845 10.9654Z"
        fill="#000A13"
        fillRule="evenodd"
      />
    </svg>
  );
}

TripAdvisor.propTypes = propTypes;
TripAdvisor.defaultProps = defaultProps;

export default TripAdvisor;
